var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#95A6B0",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(0.333333, 0.253906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,8.33333333 C8.63181017,8.33333333 8.33333333,8.63181017 8.33333333,9 L8.33333333,13 L1,13 C0.631810167,13 0.333333333,12.7015232 0.333333333,12.3333333 L0.333333333,1 C0.333333333,0.631810167 0.631810167,0.333333333 1,0.333333333 L12.3333333,0.333333333 C12.7015232,0.333333333 13,0.631810167 13,1 L13,8.33333333 L9,8.33333333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,8.33333333 L8.33333333,13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,14.3333333 L11.6666667,14.3333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,15.6666667 L11.6666667,15.6666667"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/Invoices.176675302b0ee3c46c2d0f8363ec50c9.svg";
export { ForwardRef as ReactComponent };